import React from "react";

import "./Loading.css";

interface Props {
    text: string;
}

const Loading: React.FC<Props> = function ({ text }: Props) {
    return (
        <div className="loading">
            <div className="loading__text">{text}</div>
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loading;
